import React from "react";
import { connect } from "react-redux";

interface Props {
  airportCode: string;
  airports: any[];
}

const AirportTitle = ({ airportCode, airports }: Props) => {
  const airportTitle = airports.find((airport) => airport.Code === airportCode);
  if (airportTitle === undefined) {
    return null;
  }
  return (
    <span>
      <b>{airportTitle.$t}</b> ({airportCode})
    </span>
  );
};

const mapStateToProps = (state) => ({
  airports: state.storage.airportDestinations,
});

export default connect(mapStateToProps)(AirportTitle);
